import { definePreset } from "@primeuix/themes";
import Aura from "@primeuix/themes/aura";
import { useEnvironment } from "../composables/useEnvironment";

// Primary palettes, one per environment. The active palette is chosen by name
// from ENV_CONFIG in composables/useEnvironment.js, so an entry here is only
// reachable if some environment names it. Adding an environment means adding
// its palette here too.
const primaryColors = [
    {
        name: "green",
        palette: {
            50: "#f0fdf4",
            100: "#dcfce7",
            200: "#bbf7d0",
            300: "#86efac",
            400: "#4ade80",
            500: "#22c55e",
            600: "#16a34a",
            700: "#15803d",
            800: "#166534",
            900: "#14532d",
            950: "#052e16"
        }
    },
    {
        name: "amber",
        palette: {
            50: "#fffbeb",
            100: "#fef3c7",
            200: "#fde68a",
            300: "#fcd34d",
            400: "#fbbf24",
            500: "#f59e0b",
            600: "#d97706",
            700: "#b45309",
            800: "#92400e",
            900: "#78350f",
            950: "#451a03"
        }
    },
    {
        name: "rose",
        palette: {
            50: "#fff1f2",
            100: "#ffe4e6",
            200: "#fecdd3",
            300: "#fda4af",
            400: "#fb7185",
            500: "#f43f5e",
            600: "#e11d48",
            700: "#be123c",
            800: "#9f1239",
            900: "#881337",
            950: "#4c0519"
        }
    },
    {
        name: "giddyup",
        palette: {
            50: "#e6f7ff",
            100: "#bae6ff",
            200: "#8dd4ff",
            300: "#5fc2ff",
            400: "#32b0ff",
            500: "#00BAFF",
            600: "#0099cc",
            700: "#007799",
            800: "#005566",
            900: "#003333",
            950: "#001a1f"
        }
    }
];

const { envPalette } = useEnvironment();
const color = primaryColors.find(c => c.name === envPalette) || primaryColors.find(c => c.name === "giddyup");

export const stylePreset = definePreset(Aura, {
    semantic: {
        primary: color.palette,
        colorScheme: {
            light: {
                primary: {
                    color: "{primary.500}",
                    contrastColor: "#ffffff",
                    hoverColor: "{primary.600}",
                    activeColor: "{primary.700}"
                },
                highlight: {
                    background: "{primary.50}",
                    focusBackground: "{primary.100}",
                    color: "{primary.700}",
                    focusColor: "{primary.800}"
                }
            },
            dark: {
                primary: {
                    color: "{primary.400}",
                    contrastColor: "{surface.900}",
                    hoverColor: "{primary.300}",
                    activeColor: "{primary.200}"
                },
                highlight: {
                    background: "color-mix(in srgb, {primary.400}, transparent 84%)",
                    focusBackground: "color-mix(in srgb, {primary.400}, transparent 76%)",
                    color: "rgba(255,255,255,.87)",
                    focusColor: "rgba(255,255,255,.87)"
                }
            }
        }
    }
});
